import { useEffect, useState } from 'react';
import { useGetFilesTaxOrders, useTaxOrders } from 'app/utils/services/taxOrdersService';

const tableHeader = [
  {
    id: '1',
    name: 'Tarix',
  },
  {
    id: '2',
    name: 'Adı',
  },
  {
    id: '3',
    name: 'Nömrə',
  },
  {
    id: '4',
    name: 'Məbləğ',
  },
  {
    id: '5',
    name: 'Hesab',
  },
  {
    id: '6',
    name: 'Hesabın valyutası',
  },
];

const usePaymentOrdersPage = () => {
  const [btnId, setBtnId] = useState(1);
  const { isLoadingTaxOrders, dataTaxOrders } = useTaxOrders();
  const { isSuccessFilesTaxOrders, dataFilesTaxOrders, filesTaxOrdersMutation } = useGetFilesTaxOrders();

  useEffect(() => {
    if (isSuccessFilesTaxOrders && dataFilesTaxOrders?.file_url) {
      window.open(dataFilesTaxOrders?.file_url);
    }
  }, [dataFilesTaxOrders]);

  const handleGetFiles = (taxNumber: string) => {
    filesTaxOrdersMutation({ data: { tax_number: taxNumber }, url: dataTaxOrders?.business_key });
  };

  return {
    btnId,
    setBtnId,
    tableHeader,
    dataTaxOrders,
    isLoadingTaxOrders,
    handleGetFiles,
  };
};

export default usePaymentOrdersPage;
